export const AREAS_CHAVE_GESTAO_MUNICIPAL = [
  "Desenvolvimento Econômico e Empreendedorismo Sustentável",
  "Educação, Inovação e Capital Humano",
  "Infraestrutura, Mobilidade e Sustentabilidade Urbana",
  "Governança, Gestão Pública e Inclusão Social",
];
